import { Column } from '../../model/common/column';
import { SelectItem } from '@openng/optimus-ui/api';

const trueFalse: SelectItem[] = [
  {
    label: 'Choose',
    value: null,
  },
  {
    label: 'true',
    value: true,
  },
  {
    label: 'false',
    value: false,
  },
];

export function getMOCEventAcknowledgementColumns(): Column[] {
  return [
    {
      field: 'controller',
      header: 'CRM.LABEL.CONTROLLER',
      formatPattern: 'text',
      width: '34%',
      sortable: false,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'acknowledged',
      header: 'CRM.LABEL.ACKNOWLEDGED',
      formatPattern: 'text',
      type: 'dropdown',
      width: '33%',
      sortable: true,
      filterable: true,
      options: trueFalse,
      matchMode: 'equals',
    },
    {
      field: 'completedDt',
      header: 'CRM.LABEL.COMPLETED_DATE',
      formatPattern: 'text',
      width: '33%',
      sortable: false,
      filterable: false,
    },
  ];
}
